import { Outlet } from 'react-router-dom';
import { AuthPageShell, SideRailShell } from '@/components';
import { useIsDoctor } from '@/auth.ts';
import { ROUTES } from '@/routes.ts';
import { InboxIcon, ShieldCheckIcon, CreditCardIcon, BarChartIcon, UserIcon, MessageIcon } from '@/components/icons.tsx';

export function DoctorDashboard() {
  const isDoctor = useIsDoctor();

  if (!isDoctor) {
    return (
      <AuthPageShell>
        <p className="text-muted status-message">U heeft geen toegang tot dit scherm. Enkel artsen hebben toegang tot administratie.</p>
      </AuthPageShell>
    );
  }

  return (
    <SideRailShell
      label="Dashboard navigatie"
      items={[
        { to: ROUTES.doctorConsultations, label: 'Consultaties', icon: <InboxIcon size={20} /> },
        { to: ROUTES.doctorPayments,      label: 'Betalingen',   icon: <CreditCardIcon size={20} /> },
        { to: ROUTES.doctorStatistics,    label: 'Statistieken', icon: <BarChartIcon size={20} /> },
      ]}
      bottomItems={[
        { to: ROUTES.doctorProfile,        label: 'Profiel',            icon: <UserIcon size={20} /> },
        { to: ROUTES.doctorVerification,   label: 'Verificatie',        icon: <ShieldCheckIcon size={20} /> },
        { to: ROUTES.doctorSupportTickets, label: 'Feedback & support', icon: <MessageIcon size={20} /> },
      ]}
    >
      <Outlet />
    </SideRailShell>
  );
}
